
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {TagService} from '../../../core/services/tag.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


import {FuseUtils} from '../../../core/fuseUtils';
import {FormGroup} from '@angular/forms';
import {TutorialFormDialogComponent} from './setting-form/setting-form.component';
import {UserService} from "../../../core/services/users.service";
import {DomSanitizer} from "@angular/platform-browser";
import {NgxSpinnerService} from "ngx-spinner";
import {ToastrService } from "ngx-toastr";
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'tutorial-page',
    templateUrl: './tutorial.component.html',
    styleUrls: ['./tutorial.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class TutorialComponent implements OnInit {

  tutorials;
  dialogRef: any;
  write = false;
  sortList = false;
  term;
  constructor (private http: HttpClient , private userService: UserService , public dialog: MatDialog,
               public snackBar: MatSnackBar, private spinner: NgxSpinnerService, public toastr: ToastrService,
               public translate: TranslateService) {
  }

  ngOnInit () {
    this.spinner.show();
    this.translate.onLangChange.subscribe(lang => {
      this.getDataTutorial();
    });
    this.getDataTutorial();
  }

  getDataTutorial () {
    this.spinner.show();
     this.userService.getTutorial().subscribe((res: any) => {
       if (res.data) {
         this.tutorials = res.data;
         this.write = res.write;
       }
       this.spinner.hide();
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tutorials, event.previousIndex, event.currentIndex);
    console.log(this.tutorials);
    let i = 0;
    this.tutorials.map((item) => {
      i++;
      item.sort = i;
    });
    this.userService.updateSort(this.tutorials).subscribe();
  }

  newType () {
    this.dialogRef = this.dialog.open(TutorialFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response) => {
      if (response) {
        const data = response;
        this.userService.addTutorial(data).subscribe((res) => {
          if (res) {
            this.toastr.success('Tutorial added', 'Success!');
           this.getDataTutorial();
          }
        }, error => {
          this.toastr.error('Tutorial fail', 'Error!');
        } );
      }
      });

  }

  show (data) {
    this.dialogRef = this.dialog.open(TutorialFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        action: 'show',
        data: data
      }
    });
  }

  editType (type, event) {
    event.stopPropagation();
    this.dialogRef = this.dialog.open(TutorialFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw',
      data: {
        data: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        // console.log(response);
        const actionType: string = response[ 0 ];

        switch (actionType) {
          /**
           * Save
           */
          case 'save':

            const data = response[1];
            data.id = type.id;
            this.userService.addTutorial(data).subscribe((res) => {
              if (res) {
                this.toastr.success('Tutorial updated', 'Success!');
                this.getDataTutorial();
              }
            }, error => {
              this.toastr.error('Tutorial fail', 'Error!');
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.userService.deleteTutorial(type.id).subscribe((res) => {
              if (res) {
                this.toastr.success('Tutorial deleted', 'Success!');
                this.getDataTutorial();
              }
            }, error => {
              this.toastr.error('Tutorial fail', 'Error!');
            });

            break;
        }
      });
  }
}

